import React from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { config } from './Config';
import { getUserDetails } from './GraphService';
import { getTokenFromStorageAccount } from './StorageAccountService';
import { setAuthenticated, setNotAuthenticated } from '../AppSlice';
import store from '../app/store';

export const publicClientApplication = new PublicClientApplication({
  auth: {
    clientId: config.azureAD.appID,
    redirectUri: config.azureAD.redirectUri,
    authority: config.azureAD.authority,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true
  }
});

export default function withAuthProvider(WrappedComponent) {
  class AuthProvider extends React.Component {

    async componentDidMount() {

      const accounts = publicClientApplication.getAllAccounts();
      if (accounts && accounts.length > 0) {
        try {
          var user = await getUserProfile();
          this.props.setAuthenticated(user);
        }
        catch (err) {

        }
      }
    }

    render() {
      return <WrappedComponent
        login={() => login()}
        logout={() => logout()}
        test={() => familyApiFetch()}
        {...this.props} />;
    }
  }

  const mapDispatchToProps = (dispatch) => ({
    setAuthenticated: bindActionCreators(setAuthenticated, dispatch),
  });

  return connect(
    null,
    mapDispatchToProps
  )(AuthProvider);
}

export async function getUserProfile() {
  try {
    var accessToken = await getAccessTokenGraph(config.azureAD.scopesGraph);
    if (accessToken) {
      // Get the user's profile from Graph
      return await getUserDetails(accessToken);
    }
  }
  catch (err) {
    throw err;
  }
}

export function normalizeError(error) {
  var normalizedError = {};
  if (typeof (error) === 'string') {
    var errParts = error.split('|');
    normalizedError = errParts.length > 1 ?
      { message: errParts[1], debug: errParts[0] } :
      { message: error };
  } else {
    normalizedError = {
      message: error.message,
      debug: JSON.stringify(error)
    };
  }
  return normalizedError;
}

export async function getAccessTokenGraph(scopesGraph) {
  try {
    const accounts = publicClientApplication
      .getAllAccounts();
    if (accounts.length <= 0) throw new Error('login_required');
    var silentResult = await publicClientApplication
      .acquireTokenSilent({
        scopes: scopesGraph,
        account: accounts[0]
      });

    return silentResult.accessToken;
  } catch (err) {
    if (isInteractionRequired(err)) {
      var interactiveResult = await publicClientApplication
        .acquireTokenPopup({
          scopes: scopesGraph
        });

      return interactiveResult.accessToken;
    } else {
      throw err;
    }
  }
}

export function logout() {
  publicClientApplication.logout();
}

export async function login() {
  try {
    // Login via popup
    await publicClientApplication.loginPopup(
      {
        scopes: config.azureAD.scopesGraph,
        prompt: "select_account"
      });

    // After login, get the user's profile
    var user = await getUserProfile();
    store.dispatch(setAuthenticated(user));
  }
  catch (err) {
    store.dispatch(setNotAuthenticated());
    console.log(err);
  }
}


export function isInteractionRequired(error) {
  if (!error.message || error.message.length <= 0) {
    return false;
  }

  return (
    error.message.indexOf('consent_required') > -1 ||
    error.message.indexOf('interaction_required') > -1 ||
    error.message.indexOf('login_required') > -1 ||
    error.message.indexOf('no_account_in_silent_request') > -1
  );
}

export async function getAccessTokenStorageAccount() {
  try {
    const accounts = publicClientApplication
      .getAllAccounts();
    if (accounts.length <= 0) throw new Error('login_required');

    var silentResult = await publicClientApplication
      .acquireTokenSilent({
        scopes: config.azureAD.scopesStorageAccount,
        account: accounts[0]
      });

    return silentResult.accessToken;
  } catch (err) {
    if (isInteractionRequired(err)) {
      await login();
      await getAccessTokenStorageAccount();
    } else {
      throw err;
    }
  }
}

export async function getAccessTokenFamilyApi() {
  try {
    const accounts = publicClientApplication
      .getAllAccounts();
    if (accounts.length <= 0) throw new Error('login_required');

    var silentResult = await publicClientApplication
      .acquireTokenSilent({
        scopes: config.azureAD.scopesFamilyApi,
        account: accounts[0]
      });

    return silentResult.accessToken;
  } catch (err) {
    if (isInteractionRequired(err)) {
      await login();
      await getAccessTokenFamilyApi();
    } else {
      throw err;
    }
  }
}


export async function familyApiFetch(fetch, url, options) {
  var token = await getAccessTokenFamilyApi();
  const o = options;
  if (!o.headers) o.headers = {};
  o.headers.Authorization = `Bearer ${token}`;
  return fetch(url, options);
}
